import type { Resource } from '../../';
export const order_orderSummary_giftCard: Resource = {"default":"Digital Gift Card"};
